import createDOMPurify from 'dompurify';

 const purifyHTML = (string) => {
  const DOMPurify = createDOMPurify(window);
  DOMPurify.setConfig({ ADD_ATTR: ['target'] });
  return { __html: DOMPurify.sanitize(string) }
}

export default purifyHTML;



// WEBPACK FOOTER //
// ./src/utils/purifyHTML.js